import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeworkDetailComponent } from '@modules/homework/homework-detail/homework-detail.component';

import { ForgotpwComponent } from './shared/components/forgotpw/forgotpw.component';
import { LoginComponent } from './shared/components/login/login.component';
import { SignupComponent } from './shared/components/signup/signup.component';
import { AuthGuard } from './shared/guards/auth.guard';
import {EmbeddedFileViewerComponent} from './shared/components/embedded-file-viewer/embedded-file-viewer.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgotpw', component: ForgotpwComponent },
  {
    path: 'infor',
    loadChildren: () => import('./modules/infors/infor.module').then(m => m.InforModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'assess',
    loadChildren: () => import('./modules/assess/assess.module').then(m => m.AssessModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'study',
    loadChildren: () => import('./modules/homework/homework.module').then(m => m.HomeworkModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'study',
    loadChildren: () => import('./modules/self-evaluation/self-evaluation.module').then(m => m.SelfEvaluationModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'study',
    loadChildren: () => import('./modules/study/study.module').then(m => m.StudyModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'plan',
    loadChildren: () => import('./modules/plan/plan.module').then(m => m.PlanModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'schedule',
    loadChildren: () => import('./modules/schedule/schedule.module').then(m => m.ScheduleModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'rate',
    loadChildren: () => import('./modules/rate/rate.module').then(m => m.RateModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'speech',
    loadChildren: () => import('./modules/speech/speech.module').then(m => m.SpeechModule),
    canActivate: [AuthGuard]
  },
  { path: 'homework-detail/:id', component: HomeworkDetailComponent },
  {
    path: 'file-viewer',
    component: EmbeddedFileViewerComponent
  },
  {
    path: 'chat',
    loadChildren: () => import('./modules/chat/chat.module').then(m => m.ChatModule),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
